import { type ButtonHTMLAttributes, forwardRef, type Ref } from 'react';
import { StyledButton } from './FormButton.styles';
import ButtonSpinnerPrimary from './ButtonSpinners/ButtonSpinnerPrimary';
import ButtonSpinner from './ButtonSpinners/ButtonSpinner';
import { type LinkVariant } from '@/components/Link/Link.styles';

export type FormButtonVariant = Exclude<
  LinkVariant,
  'nav_text_link' | 'tab_primary' | 'tab_primary_small'
>;
interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'ref'> {
  variant?: FormButtonVariant;
  isLoading?: boolean;
}

const FormButton = forwardRef(
  (
    { isLoading, disabled, children, variant, ...rest }: ButtonProps,
    ref?: Ref<HTMLButtonElement>
  ) => {
    const primaryVariants = ['primary', 'primary_small', 'primary_tiny'];
    const isPrimaryVariant = primaryVariants.includes(variant!);

    return (
      <StyledButton
        as="button"
        ref={ref}
        disabled={isLoading || disabled}
        variant={variant}
        {...rest}
      >
        {children}
        {isPrimaryVariant && isLoading ? <ButtonSpinnerPrimary /> : isLoading && <ButtonSpinner />}
      </StyledButton>
    );
  }
);

export default FormButton;
